import PricingDefaultsElement from "./PricingDefaultsElement";
import {
  AddRounded as AddIcon,
  Delete as DeleteIcon,
} from "@mui/icons-material";
import { Fab, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import * as ids from "common/ids";
import IconButton from "components/common/IconButton";
import { useEffect, useState } from "react";

const LayersElement = ({ label, data, onChange }) => {
  const theme = useTheme();
  const [layers, setLayers] = useState([]);

  useEffect(() => {
    if (data?.layers?.length) {
      setLayers(data.layers);
    } else if (layers.length === 0) {
      setLayers([
        {
          id: ids.makeNewId(),
          limit: null,
          aggregate: null,
          deductible: null,
        },
      ]);
    }
  }, [data?.layers, layers]);

  const addLayer = () => {
    const updatedLayers = [
      ...layers,
      {
        id: ids.makeNewId(),
        limit: null,
        aggregate: null,
        deductible: null,
      },
    ];
    setLayers(updatedLayers);
    onChange(updatedLayers);
  };

  const removeLayer = (layerId) => {
    const updatedLayers = layers.filter((x) => x.id !== layerId);
    setLayers(updatedLayers);
    onChange(updatedLayers);
  };

  const updateLayer = (layerId, value) => {
    const updatedLayers = layers.map((layer) => {
      return layer.id === layerId
        ? {
            ...layer,
            ...value,
          }
        : layer;
    });
    setLayers(updatedLayers);
    onChange(updatedLayers);
  };

  return (
    <>
      <Typography variant={"h6"} paddingTop={2}>
        {label}
      </Typography>
      {layers.map((layer, index) => {
        const layerData = layers.filter((x) => x.id === layer.id)?.[0] ?? {};
        return (
          <Stack key={layer.id} className={"fade-in-slow"}>
            <Stack
              direction={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
              marginTop={1}
            >
              <b style={{ lineHeight: "40px" }}>{`Option ${index + 1}`}</b>
              {layers.length > 1 && (
                <IconButton
                  icon={DeleteIcon}
                  onClick={() => removeLayer(layer.id)}
                />
              )}
            </Stack>
            <PricingDefaultsElement
              label={"Limit / Agg. Limit"}
              options={[
                { limit: 100_000, aggregate: 100_000 },
                { limit: 100_000, aggregate: 250_000 },
                { limit: 250_000, aggregate: 250_000 },
                { limit: 250_000, aggregate: 500_000 },
                { limit: 250_000, aggregate: 1_000_000 },
                { limit: 500_000, aggregate: 500_000 },
                { limit: 500_000, aggregate: 1_000_000 },
                { limit: 500_000, aggregate: 2_000_000 },
                { limit: 1_000_000, aggregate: 1_000_000 },
                { limit: 1_000_000, aggregate: 2_000_000 },
                { limit: 2_000_000, aggregate: 2_000_000 },
              ]}
              data={layerData}
              onChange={(value) => updateLayer(layer.id, value)}
            />
            <PricingDefaultsElement
              label={"Deductible"}
              options={[
                { deductible: 0 },
                { deductible: 50 },
                { deductible: 100 },
                { deductible: 250 },
                { deductible: 500 },
                { deductible: 750 },
                { deductible: 1_000 },
                { deductible: 1_500 },
                { deductible: 2_500 },
                { deductible: 5_000 },
                { deductible: 7_500 },
                { deductible: 10_000 },
                { deductible: 15_000 },
                { deductible: 20_000 },
                { deductible: 25_000 },
                { deductible: 35_000 },
                { deductible: 50_000 },
              ]}
              data={layerData}
              onChange={(value) => updateLayer(layer.id, value)}
            />
          </Stack>
        );
      })}
      <Fab
        size={"small"}
        color={"primary"}
        sx={{ margin: "1rem auto 0 auto", boxShadow: "none", zIndex: "0" }}
        onClick={() => addLayer()}
      >
        <AddIcon sx={{ color: theme.brand.white, fontSize: "1.875rem" }} />
      </Fab>
    </>
  );
};

export default LayersElement;
